import * as v from 'valibot';

export const nulltoOptional = <
  TWrapped extends v.BaseSchema<unknown, unknown, v.BaseIssue<unknown>>,
  TDefault extends v.Default<TWrapped, null | undefined>,
>(
  wrapped: TWrapped,
  defaultValue?: TDefault,
) => {
  return v.optional(
    v.pipe(
      v.nullish(wrapped, defaultValue),
      v.transform(val => (val === null ? undefined : val)),
    ),
  );
};

export const optionalString = nulltoOptional(v.string());

export const optionalNumber = nulltoOptional(v.number());

export const parseValiError = (issue: v.BaseIssue<unknown>): string => {
  return `${issue.message} at ${v.getDotPath(issue)}`;
};

const webAddressSchema = v.pipe(
  v.string(),
  v.trim(),
  v.url(),
  v.check(input => {
    return input.startsWith('http://') || input.startsWith('https://');
  }, 'URL must use http: or https: protocol'),
);

const absolutePathSchema = v.pipe(v.string(), v.trim(), v.startsWith('/'));

export const safeUrlString = v.pipe(
  v.string(),
  v.trim(),
  v.union([webAddressSchema, absolutePathSchema]),
);

export const stringOrArrayToString = v.pipe(
  v.union([v.array(v.string()), v.string()]),
  v.transform(input => {
    const str = Array.isArray(input) ? input[0] : input;
    return str !== '' ? str : undefined;
  }),
);
